import URL from "../config/api";
import axios from "../config/axios";

const actions = {
  insert: 5,
  update: 6,
  delete: 7,
  access: 8
};

export const log = async (
  action,
  route,
  description,
  objId,
  token,
  obj2_id = null,
  school_id = null
) => {
  const obj = {
    action_id: actions[action],
    link_id: route,
    description,
    obj1: objId,
    obj2: obj2_id,
    url: window.location.href,
    school_id
  };

  await axios.post(`${URL.api}audict/log/insert`, obj, {
    headers: {
      authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*"
    }
  });
};
